var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSparkles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    stroke: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99727 1.99651C4.99727 4.20657 3.20566 5.99818 0.995605 5.99818C3.20566 5.99818 4.99727 7.78978 4.99727 9.99984M4.99727 1.99651C4.99727 4.20657 6.78888 5.99818 8.99894 5.99818C6.78888 5.99818 4.99727 7.78978 4.99727 9.99984M4.99727 1.99651L4.99727 0.996094M4.99727 9.99984L4.99727 11.0003M16.0019 14.0015C16.0019 11.2389 13.7623 8.99943 10.9998 8.99943C13.7623 8.99943 16.0019 6.75992 16.0019 3.99734M16.0019 14.0015C16.0019 11.2389 18.2414 8.99943 21.0039 8.99943C18.2414 8.99943 16.0019 6.75992 16.0019 3.99734M16.0019 14.0015L16.0019 15.0019M16.0019 3.99734L16.0019 2.99693M8.99894 20.004V21.0044M8.99894 13.0011V12.0007M8.99894 12.5009C8.99894 14.7109 7.20733 16.5026 4.99727 16.5026C7.20733 16.5026 8.99894 18.2942 8.99894 20.5042C8.99894 18.2942 10.7905 16.5026 13.0006 16.5026C10.7905 16.5026 8.99894 14.7109 8.99894 12.5009Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkles);
export default __webpack_public_path__ + "static/media/sparkles.85f11571d6d5dd0ba2fe3fe43c501df9.svg";
export { ForwardRef as ReactComponent };